import script from "./LoginModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginModal.vue?vue&type=script&setup=true&lang=js"

import "./LoginModal.vue?vue&type=style&index=0&id=51a021a5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51a021a5"]])

export default __exports__